import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { computed, observable, action } from 'mobx';
import _ from 'lodash';
import moment from 'moment';
import { isValid } from 'ipaddr.js';
import { Text } from '../common';
import Button from '../common/FormComponents/Button';

@observer
class ReservationTimesContainer extends Component {
  calculateDays() {
    const { reservationId } = this.props;
    //Must create time blocks from the ranges
  }
  render() {
    return <ReservationTimes />;
  }
}

@observer
export class Time extends Component {
  @computed
  get hoverColor() {
    const { isValidReservationSelection } = this.props;
    if (isValidReservationSelection) return 'hover-primary';
    return '';
  }
  @computed
  get backgroundColor() {
    const {
      isValidReservationSelection,
      isReservationDay,
      isCurrentReservation,
      isReservationSelection,
      isReservation,
      isBlocked,
      isPending,
    } = this.props;
    if (isReservationDay) {
      if (isReservationSelection) return 'bg-primary';
      if (!isValidReservationSelection) return 'bg-white';
      return 'bg-transparent';
    }
    if (isReservation && !isReservationSelection) {
      return isPending ? 'bg-transparent' : 'bg-grayMedium';
    }
    if (isBlocked) {
      return 'bg-offWhite';
    }
  }
  @computed
  get clickable() {
    return this.hoverColor === 'hover-primary';
  }

  render() {
    const {
      hovering,
      block,
      setDate,
      isReservationDay,
      updateHover,
    } = this.props;
    const clickable = this.clickable ? 'pointer' : '';
    const hoverStr = `${this.hoverColor} ${
      this.backgroundColor
    } f-1 h-3 relative ${clickable}`;
    return (
      <div
        name="hover-block"
        className={hoverStr}
        title={block.date}
        onClick={
          this.clickable
            ? () => {
                console.log('block', block);
                setDate(block.date);
              }
            : null
        }
        onMouseEnter={() => updateHover(block)}
        onMouseLeave={() => updateHover(null)}
      >
        {block.order % 12 == 0 &&
        block.order !== 0 &&
        (hovering || isReservationDay) ? (
          <div
            name="time-label"
            className="o-visisble absolute top--6 left-6 f-cc z-20"
          >
            {block.order / 4}
          </div>
        ) : null}
      </div>
    );
  }
}

@observer
export class Day extends Component {
  @observable hovering = false;

  isValidReservationSelection(block) {
    const {
      day,
      reservationStartDate,
      reservationEndDate,
      selectedStartTime,
      selectedEndTime,
      oneDayLater,
    } = this.props;
    let isValid = false;
    const blockDate = moment(block.date);
    if (
      blockDate.isSame(reservationStartDate, 'day') ||
      blockDate.isSame(reservationEndDate, 'day')
    ) {
      if (selectedStartTime && !selectedEndTime) {
        if (
          blockDate.isSameOrAfter(selectedStartTime) &&
          blockDate.isSameOrBefore(
            moment(reservationEndDate).format('YYYY-MM-DD') +
              ' ' +
              oneDayLater.format('HH:mm'),
          )
        ) {
          isValid = true;
        } else {
          isValid = false;
        }
      } else if (!selectedStartTime) {
        isValid = true;
      } else {
        isValid = false;
      }
    }
    return isValid;
  }

  render() {
    const {
      day,
      reservationStartDate,
      reservationEndDate,
      reservationId,
      selectedStartTime,
      selectedEndTime,
      setDate,
      updateHover,
    } = this.props;
    const { isWholeDay } = day;
    const isBlocked = day.isBlocked;
    const reservationDate = day.dayStr;
    const isReservationDay =
      moment(reservationDate).isSame(reservationStartDate, 'day') ||
      moment(reservationDate).isSame(reservationEndDate, 'day');
    return (
      <div
        className={`b-1 b-offWhite f f-1 f-rows relative ${
          isReservationDay ? 'bg-pattern' : isWholeDay ? 'bg-pattern-2' : null
        }`}
        onMouseEnter={e => (this.hovering = true)}
        onMouseLeave={e => (this.hovering = false)}
      >
        <div
          name="date-label"
          className="absolute top-5 left-5 z-20 h7 grayDarkMedium"
        >
          {day.readableMonthStr}
        </div>
        {_.map(day.timeBlocks, x => {
          return (
            <Time
              isReservation={x.reservationId}
              isBlocked={isBlocked}
              isCurrentReservation={x.id === reservationId}
              isReservationSelection={moment(x.date).isBetween(
                selectedStartTime,
                selectedEndTime,
              )}
              isReservationDay={isReservationDay}
              isValidReservationSelection={this.isValidReservationSelection(x)}
              hovering={this.hovering}
              block={x}
              setDate={setDate}
              updateHover={updateHover}
              isPending={x.pending}
            />
          );
        })}
      </div>
    );
  }
}

@observer
export class ReservationTimes extends Component {
  @observable selectedStartTime = null;
  @observable selectedEndTime = null;
  @observable settingStart = true;
  @observable currentHover = null;

  @computed
  get startTime() {
    return this.selectedStartTime
      ? moment(this.selectedStartTime).format('MMM DD HH:mm')
      : this.currentHover
      ? this.currentHover.format('MMM DD HH:mm')
      : 'Select a time above';
  }
  @computed
  get endTime() {
    return this.selectedEndTime
      ? moment(this.selectedEndTime).format('MMM DD HH:mm')
      : this.selectedStartTime && this.currentHover
      ? this.currentHover.format('MMM DD HH:mm')
      : 'Select a time above';
  }

  @computed
  get oneDayLater() {
    const reservationEndDate = moment(this.props.reservation.checkOut).format(
      'YYYY-MM-DD',
    );
    let oneDay = moment(this.selectedStartTime)
      .add(1, 'day')
      .add(2, 'hours');
    let endDayTime = moment(reservationEndDate)
      .hour(25)
      .minute(59);

    if (oneDay > endDayTime) {
      oneDay = endDayTime;
    }
    return oneDay;
  }

  @action.bound
  setSelectedTime(dateTime) {
    const { updateTimes } = this.props;
    console.log('Setting Time', dateTime, this.settingStart);
    if (this.settingStart) {
      this.selectedStartTime = dateTime;
    } else {
      this.selectedEndTime = dateTime;
      updateTimes && updateTimes(this.selectedStartTime, this.selectedEndTime);
    }
    this.settingStart = !this.settingStart;
  }

  @action.bound
  updateHover(block) {
    console.log('updating hover', block);
    this.currentHover = block ? moment(block.date) : null;
  }

  @action.bound
  clear() {
    this.selectedStartTime = null;
    this.selectedEndTime = null;
    this.settingStart = true;
  }

  render() {
    const { days, reservation, close, save } = this.props;
    // console.log('ReservationTimes.js - ', days.sorted);
    const reservationStartDate = moment(reservation.checkIn).format(
      'YYYY-MM-DD',
    );
    const reservationEndDate = moment(reservation.checkOut).format(
      'YYYY-MM-DD',
    );

    return (
      <div className="f-rows f-center-stretch">
        <div
          className={
            'relative g g-tc-fr-' +
            (days.sorted && days.sorted.length < 7 ? days.sorted.length : 7)
          }
        >
          {days.sorted.map(d => {
            return (
              <Day
                day={d}
                reservationStartDate={reservationStartDate}
                reservationEndDate={reservationEndDate}
                reservationId={reservation.id}
                setDate={this.setSelectedTime}
                selectedStartTime={this.selectedStartTime}
                selectedEndTime={this.selectedEndTime}
                oneDayLater={this.oneDayLater}
                updateHover={this.updateHover}
              />
            );
          })}
          {this.selectedStartTime && this.selectedEndTime && (
            <div
              className="absolute top-0 left-0 bottom-0 right-0 bg-grayDark o-60 h6 f-cc my-none"
              onClick={this.clear}
            >
              <div className="bg-white p-l grayDarkMedium o-100">
                <Text large>Click to clear</Text>
              </div>
            </div>
          )}
        </div>
        <div className="g g-tc-fr-2 f-ji-stretch g-g-sxx">
          <div className="p-mxx t-align-center t-lx">Pickup</div>
          <div className="p-mxx t-align-center t-lx">Return</div>
          <div
            className={
              'p-mxx t-align-center t-lx f-cc ' +
              (this.selectedStartTime ? 'bg-white' : 'bg-primaryLightFaded')
            }
          >
            <Text align="center" header>
              {this.startTime}
            </Text>
          </div>
          <div
            className={
              'p-mxx t-align-center t-lx f-cc ' +
              (this.selectedStartTime && !this.selectedEndTime
                ? 'bg-primaryLightFaded'
                : 'bg-white')
            }
          >
            <Text align="center" header>
              {' '}
              {this.endTime}
            </Text>
          </div>
        </div>
      </div>
    );
  }
}

export default ReservationTimesContainer;

/*
  ADD CONTAINER
  Must give reservationId
   -> Display with available time ranges visible, limit return to 24 hour window
  reservation start date and endate and start time and end time given -> Dispaly with available time ranges visible

  -> Returns start and end time on selection complete
*/



// WEBPACK FOOTER //
// ./src/components_new/reservation/ReservationTimes.js